import React from "react";
import { TfiArrowTopRight } from "react-icons/tfi";
import BannerInfoScroll from "./BannerInfoScroll";
import BannerGallery from "./BannerGallery";

const HomeBanner = () => {
  return (
    <div className="pt-24 md:pt-16">
      <section className="relative isolate overflow-hidden flex flex-col md:flex-row justify-between gap-8 md:items-end px-5 md:px-10 py-8 md:py-12">
        <svg
          viewBox="0 0 346 328"
          fill="none"
          aria-hidden="true"
          className="pointer-events-none absolute -z-10 hidden md:block md:right-8 -bottom-1 md:w-[540px] opacity-[0.10]"
        >
          <path
            d="M173 164.5C268.102 164.5 345.23 241.462 345.499 336.5H325.739C325.47 252.374 257.189 184.26 173 184.26C88.8107 184.26 20.5304 252.374 20.2608 336.5H0.500709C0.770367 241.462 77.8976 164.5 173 164.5ZM0.500709 -8.5H20.2608C20.5304 75.6261 88.8107 143.74 173 143.74C257.189 143.74 325.47 75.6261 325.739 -8.5H345.499C345.23 86.5392 268.102 163.5 173 163.5C77.8976 163.5 0.770365 86.5392 0.500709 -8.5ZM173 121.98C100.829 121.98 42.2904 63.6082 42.0209 -8.5H61.7811C62.0504 52.6951 111.742 102.22 173 102.22C234.258 102.22 283.95 52.6951 284.219 -8.5H303.979C303.71 63.6082 245.172 121.98 173 121.98ZM173 80.46C123.759 80.46 83.8105 40.6773 83.5414 -8.5H103.302C103.571 29.7641 134.673 60.7 173 60.7C211.327 60.7 242.429 29.7641 242.698 -8.5H262.459C262.19 40.6773 222.241 80.46 173 80.46ZM173 206.02C245.172 206.02 303.71 264.391 303.979 336.5H284.219C283.95 275.305 234.258 225.78 173 225.78C111.742 225.78 62.0504 275.305 61.7811 336.5H42.0209C42.2904 264.391 100.829 206.02 173 206.02ZM173 247.54C222.241 247.54 262.19 287.322 262.459 336.5H242.698C242.429 298.237 211.327 267.3 173 267.3C134.673 267.3 103.571 298.237 103.302 336.5H83.5414C83.8105 287.322 123.759 247.54 173 247.54Z"
            fill="#A2BC6B"
          />
        </svg>
        <div className="max-w-4xl">
          <p className="text-[16px] font-[500] uppercase text-[#62646C]">
            Mary Ojo · Frontend-focused product engineer
          </p>
          <h1 className="hero-heading text-[3rem] leading-[0.98] md:text-[4.75rem] tracking-tight mt-4">
            I design and develop intelligent, usable and accessible products.
          </h1>
          <p className="text-base md:text-lg text-neutral-400 max-w-2xl mt-5 leading-relaxed">
            Software engineer combining AI, product thinking, and human-centered
            design to solve meaningful problems.
          </p>
        </div>
        <a
          href="/contact"
          className="group shrink-0 w-full md:w-[320px] rounded-2xl border border-neutral-800 bg-neutral-900/40 p-5 hover:border-[#A2BC6B]/60 transition-colors"
          aria-label="Have an idea? Let's build it together — contact Mary"
        >
          <span className="flex items-center gap-2 text-[11px] uppercase tracking-[0.14em] text-neutral-500">
            <span className="w-2 h-2 rounded-full bg-[#A2BC6B]" aria-hidden="true"></span>
            Open to collaboration
          </span>
          <span className="block text-xl md:text-2xl font-semibold mt-5">
            Have an idea?
          </span>
          <span className="flex items-center justify-between gap-4 mt-1">
            <span className="text-xl md:text-2xl font-semibold text-[#c6d5a5]">
              Let's build it together.
            </span>
            <span className="flex shrink-0 items-center justify-center w-11 h-11 rounded-full bg-[#A2BC6B] text-black group-hover:bg-[#b6ca8c] transition-colors">
              <TfiArrowTopRight aria-hidden="true" />
            </span>
          </span>
        </a>
      </section>
      <BannerInfoScroll />
      <BannerGallery />
    </div>
  );
};

export default HomeBanner;
